import * as api from '@tytapp/api';

export class AvAsset extends api.ApiAvAsset {

}